// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search button{border:none;fill:#637282;background:#f4f4f4}.search button:focus{outline:none}.popup-wrapper{min-width:calc(100% - 360px) !important}.indented{text-indent:10px}.disabled{color:gray}.template-wrapper{display:grid;grid-template-columns:auto auto}.template-name{justify-self:start}.template-description{color:gray;justify-self:end}", ""]);
// Exports
module.exports = exports;
